<template>
    <section class="app-main" :class="{ 'mobile-app': $isMobileDevice }">
        <div v-if="isLogin" class="help-flex" @click="helpFun">
            <img src="@/assets/help/help-serve.png" alt="" class="h-20 w-20" />
            Help
        </div>
        <div v-if="!$isMobileDevice" class="line"></div>
        <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key"/>
    </keep-alive> -->
        <router-view v-if="!$route.meta.keepAlive" :key="key" />
        <customerDialog
            :show-service-visibe.sync="showService"
            :content-text="$t('home_service_modal_tips_customer')"
        />
    </section>
</template>
<script>
import { openLinkInHiddenWindow } from '@/utils';
import customerDialog from '@/components/customerDialog';
import { getToken } from '@/utils/auth';
export default {
    name: 'AppMain',
    components: {
        customerDialog
    },
    data() {
        return {
            openLinkInHiddenWindow,
            showService: false,
            isLogin: getToken()
        };
    },
    computed: {
        key() {
            return this.$route.path;
        }
    },
    methods: {
        helpFun() {
            this.showService = true;
        }
    }
};
</script>
<style lang="scss" scoped>
.app-main {
    min-height: 500px;
    &.mobile-app {
        background-color: #fff;
    }
}
.line {
    width: 100%;
    height: 1px;
    background-color: #44454d;
}
.help-flex {
    position: fixed;
    right: 16px;
    bottom: 90px;
    z-index: 999;
    padding: 8px 8px;
    background-color: $basicColor;
    color: $basicWhite;
    box-shadow: 0 0px 12px rgba(255, 255, 255, 0.5);
    border-radius: 12px 12px 12px 12px;
    font-size: 16px;
    cursor: pointer;
    &:hover {
        box-shadow: 0 0px 12px rgba(255, 255, 255, 0.8);
    }
    img {
        vertical-align: bottom;
    }
}
</style>
